import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { workflowAPI } from '../../lib/api';
import { errMsg, timeAgo } from '../../lib/workflow';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export const MarkLiveDialog = ({ item, onClose, onDone }) => {
  const [url, setUrl] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { setUrl(''); }, [item]);
  const pushed = !!item?.etsy_listing?.listing_id;

  const submit = async () => {
    setBusy(true);
    try {
      const r = await workflowAPI.markLive(item.id, { etsy_url: url.trim() || undefined, force: !pushed });
      toast.success('Live on Etsy 🛍️ Handed over to Utkarsh!');
      onDone?.(r.data);
      onClose();
    } catch (e) {
      toast.error(errMsg(e, 'Could not mark live'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md bg-white rounded-3xl border-[#E8E1D5]" data-testid="mark-live-dialog">
        <DialogHeader>
          <DialogTitle className="font-jakarta text-xl">🛍️ Is it live on Etsy?</DialogTitle>
        </DialogHeader>
        {pushed ? (
          <p className="text-sm text-[#6E635B]">
            🛒 Etsy draft pushed {timeAgo(item.etsy_listing.last_pushed_at)}. Once you've published it inside Etsy, confirm here and it moves to Utkarsh for TLJ, eBay, Walmart &amp; more.
          </p>
        ) : (
          <p className="text-sm rounded-2xl bg-[#FFFBEB] border border-[#FDE68A] text-[#92400E] px-4 py-3" data-testid="mark-live-no-push-warning">
            ⚠️ No Etsy push recorded from AJHQ yet. Only confirm if this listing is already live on Etsy.
          </p>
        )}
        <Input
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Etsy listing URL (optional)"
          className="rounded-xl border-[#E8E1D5]"
          data-testid="mark-live-url-input"
        />
        <div className="flex gap-2 pt-1">
          <Button variant="outline" className="flex-1 rounded-xl" onClick={onClose}>Not yet</Button>
          <Button onClick={submit} disabled={busy} className="flex-1 rounded-xl bg-[#81B29A] hover:bg-[#6FA38B] text-white font-bold" data-testid="mark-live-confirm-btn">
            {busy ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : null} Yes, it's live 🎉
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
